import CheckIcon from '../icons/CheckIcon.svelte';
import Locked from '../icons/Locked.svelte';
import SendIcon from '../icons/SendIcon.svelte';
import TriangleWarningIcon from '../icons/TriangleWarningIcon.svelte';
export var ListingStatus;
(function (ListingStatus) {
    ListingStatus["ADDED"] = "ADDED";
    ListingStatus["APPROVED"] = "APPROVED";
    ListingStatus["IGNORED"] = "IGNORED";
    ListingStatus["MARK_FOR_REMOVAL"] = "MARK_FOR_REMOVAL";
    ListingStatus["NEEDS_REVIEW"] = "NEEDS_REVIEW";
    ListingStatus["REMOVED"] = "REMOVED";
    ListingStatus["REMOVED_BY_OTHER"] = "REMOVED_BY_OTHER";
    ListingStatus["REPORTED"] = "REPORTED";
    ListingStatus["RETRACTION_REQUESTED"] = "RETRACTION_REQUESTED";
    ListingStatus["RETRACTION_QUEUE"] = "RETRACTION_QUEUE";
    ListingStatus["UNDETERMINED"] = "UNDETERMINED";
    ListingStatus["ZOMBIE_NOT_A_STATUS"] = "ZOMBIE_NOT_A_STATUS";
    ListingStatus["MARK_FOR_RETRACTION"] = "MARK_FOR_RETRACTION";
    ListingStatus["NONE"] = "NONE";
    ListingStatus["REMOVAL_REQUESTED"] = "REMOVAL_REQUESTED";
    ListingStatus["RETRACTED"] = "RETRACTED";
    ListingStatus["SUSPECT"] = "SUSPECT";
    ListingStatus["FROZEN"] = "FROZEN";
})(ListingStatus || (ListingStatus = {}));
/**
 * NOTE: this needs work. Example, `ListingStatus.APPROVED` is an option,
 * but it's not defined in `ListingStatuses`.
 *
 * `options` are the allowed next status assignments for the current status.
 * Example: If a listing has a status 'MARK_FOR_REMOVAL' then the ui selector
 * options are 'REMOVAL_REQUESTED' and 'REMOVED_BY_OTHER'.
 */
export const ListingStatuses = {
    [ListingStatus.MARK_FOR_REMOVAL]: {
        label: 'Report',
        options: [ListingStatus.REMOVAL_REQUESTED, ListingStatus.REMOVED_BY_OTHER, ListingStatus.FROZEN],
        display: 'warning',
        displayType: 'warning'
    },
    [ListingStatus.MARK_FOR_RETRACTION]: {
        label: 'Mark for Retraction',
        options: [ListingStatus.RETRACTION_REQUESTED],
        display: 'warning',
        displayType: 'warning'
    },
    [ListingStatus.RETRACTION_QUEUE]: {
        label: 'Mark for Retraction',
        options: [ListingStatus.RETRACTION_REQUESTED],
        display: 'warning',
        displayType: 'warning'
    },
    [ListingStatus.NEEDS_REVIEW]: {
        label: 'Needs Review',
        options: [ListingStatus.APPROVED, ListingStatus.MARK_FOR_REMOVAL, ListingStatus.IGNORED, ListingStatus.FROZEN],
        display: 'warning',
        displayType: 'warning'
    },
    [ListingStatus.NONE]: {
        label: '...',
        options: [],
        display: 'indeterminate',
        displayType: 'indeterminate'
    },
    [ListingStatus.REMOVAL_REQUESTED]: {
        label: 'Removal Requested',
        options: [ListingStatus.REMOVED],
        display: 'warning',
        displayType: 'warning'
    },
    [ListingStatus.REMOVED]: {
        label: 'Removed',
        options: [ListingStatus.MARK_FOR_RETRACTION],
        display: 'light',
        displayType: 'light'
    },
    [ListingStatus.RETRACTION_REQUESTED]: {
        label: 'Retraction Requested',
        options: [ListingStatus.RETRACTED],
        display: 'warning',
        displayType: 'warning'
    },
    [ListingStatus.UNDETERMINED]: {
        label: 'Undetermined',
        options: [ListingStatus.APPROVED, ListingStatus.IGNORED, ListingStatus.MARK_FOR_REMOVAL],
        display: 'indeterminate',
        displayType: 'indeterminate'
    },
    [ListingStatus.ZOMBIE_NOT_A_STATUS]: {
        label: 'ZOMBIE_NOT_A_STATUS',
        options: [],
        display: 'indeterminate',
        displayType: 'indeterminate'
    },
    [ListingStatus.RETRACTED]: {
        label: 'Retracted',
        options: [ListingStatus.FROZEN],
        display: 'warning',
        displayType: 'warning'
    },
    [ListingStatus.APPROVED]: {
        label: 'Approved',
        options: [ListingStatus.FROZEN],
        display: 'success',
        displayType: 'success'
    },
    [ListingStatus.IGNORED]: {
        label: 'Ignored',
        options: [ListingStatus.FROZEN],
        display: 'warning',
        displayType: 'warning'
    },
    [ListingStatus.FROZEN]: {
        label: 'Frozen',
        options: [
            ListingStatus.NEEDS_REVIEW,
            ListingStatus.APPROVED,
            ListingStatus.IGNORED,
            ListingStatus.MARK_FOR_REMOVAL,
            ListingStatus.REMOVED_BY_OTHER
        ],
        display: 'ice-blue',
        displayType: 'ice-blue'
    }
};
export const statusesOrder = {
    [ListingStatus.NEEDS_REVIEW]: [
        ListingStatus.MARK_FOR_REMOVAL,
        ListingStatus.IGNORED,
        ListingStatus.APPROVED,
        ListingStatus.REMOVED
    ],
    [ListingStatus.MARK_FOR_REMOVAL]: [
        ListingStatus.REMOVAL_REQUESTED,
        ListingStatus.NEEDS_REVIEW,
        ListingStatus.IGNORED,
        ListingStatus.APPROVED,
        ListingStatus.REMOVED
    ]
};
export const sortStatuses = (statuses, currentStatus) => {
    const currentStatusOrder = statusesOrder[currentStatus] || [];
    return statuses.sort((a, b) => {
        const indexA = currentStatusOrder.indexOf(a);
        const indexB = currentStatusOrder.indexOf(b);
        if (indexA !== -1 && indexB !== -1) {
            return indexA - indexB;
        }
        if (indexA !== -1) {
            return -1;
        }
        if (indexB !== -1) {
            return 1;
        }
        // If both statuses are not found in the currentStatusOrder, treat them as equal
        return 0;
    });
};
export const ListingsDisplayInfo = {
    [ListingStatus.ADDED]: {
        icon: TriangleWarningIcon,
        label: 'Added',
        display: 'success',
        actionName: 'Add'
    },
    [ListingStatus.APPROVED]: {
        icon: TriangleWarningIcon,
        label: 'Approved',
        display: 'success',
        actionName: 'Approve'
    },
    [ListingStatus.SUSPECT]: {
        icon: TriangleWarningIcon,
        label: 'Suspect',
        display: 'danger',
        actionName: 'Suspect'
    },
    [ListingStatus.MARK_FOR_REMOVAL]: {
        icon: TriangleWarningIcon,
        label: 'Report Queue',
        filtersLabel: 'Report Queue',
        display: 'danger',
        actionName: 'Report'
    },
    [ListingStatus.MARK_FOR_RETRACTION]: {
        icon: CheckIcon,
        label: 'Mark Retracted',
        filtersLabel: 'Retraction Queue',
        display: 'warning',
        actionName: 'Mark Retracted'
    },
    [ListingStatus.NEEDS_REVIEW]: {
        icon: TriangleWarningIcon,
        label: 'Needs Review',
        display: 'warning',
        actionName: 'Needs Review'
    },
    [ListingStatus.NONE]: {
        icon: TriangleWarningIcon,
        label: '...',
        display: 'indeterminate',
        actionName: 'Unknown'
    },
    [ListingStatus.REMOVAL_REQUESTED]: {
        icon: TriangleWarningIcon,
        label: 'Reported',
        display: 'danger',
        actionName: 'Mark Reported'
    },
    [ListingStatus.REMOVED]: {
        icon: TriangleWarningIcon,
        label: 'Removed by CounterFind',
        display: 'light',
        actionName: 'Mark Removed by CounterFind'
    },
    [ListingStatus.REMOVED_BY_OTHER]: {
        icon: TriangleWarningIcon,
        label: 'Removed by Other',
        display: 'light',
        actionName: 'Mark Removed by Other'
    },
    [ListingStatus.RETRACTION_REQUESTED]: {
        icon: SendIcon,
        label: 'Retraction Requested',
        display: 'warning',
        actionName: 'Retraction Requested'
    },
    [ListingStatus.IGNORED]: {
        icon: SendIcon,
        label: 'Ignored',
        display: 'warning',
        actionName: 'Ignore'
    },
    [ListingStatus.RETRACTION_QUEUE]: {
        icon: SendIcon,
        label: 'Retraction Queue',
        display: 'warning',
        actionName: 'Request Retraction'
    },
    [ListingStatus.RETRACTED]: {
        icon: SendIcon,
        label: 'Retracted',
        display: 'warning',
        actionName: 'Mark Retracted'
    },
    [ListingStatus.REPORTED]: {
        icon: SendIcon,
        label: 'Retracted',
        display: 'warning',
        actionName: 'Retract'
    },
    [ListingStatus.UNDETERMINED]: {
        icon: TriangleWarningIcon,
        label: 'Undetermined',
        display: 'indeterminate',
        actionName: 'Undetermined'
    },
    [ListingStatus.ZOMBIE_NOT_A_STATUS]: {
        icon: TriangleWarningIcon,
        label: 'ZOMBIE_NOT_A_STATUS',
        display: 'indeterminate',
        actionName: 'Zombie'
    },
    [ListingStatus.FROZEN]: {
        icon: Locked,
        label: 'Frozen',
        display: 'ice-blue',
        actionName: 'Freeze'
    }
};
export var SellerStatus;
(function (SellerStatus) {
    SellerStatus["APPROVED"] = "APPROVED";
    SellerStatus["SUSPECT"] = "SUSPECT";
    SellerStatus["UNDETERMINED"] = "UNDETERMINED";
    SellerStatus["VIOLATOR"] = "VIOLATOR";
})(SellerStatus || (SellerStatus = {}));
/**
 * 'Violator' was removed, but is coming back. We'll need to update
 * options below when that is back in the db. (5/7/24 S.H.)
 */
export const SellerStatuses = {
    [SellerStatus.APPROVED]: {
        label: 'Approved',
        options: [SellerStatus.SUSPECT],
        display: 'success',
        displayType: 'success'
    },
    [SellerStatus.SUSPECT]: {
        label: 'Suspect',
        options: [SellerStatus.APPROVED],
        display: 'danger',
        displayType: 'danger'
    },
    [SellerStatus.UNDETERMINED]: {
        label: 'Undetermined',
        options: [SellerStatus.APPROVED, SellerStatus.SUSPECT],
        display: 'warning',
        displayType: 'warning'
    },
    [SellerStatus.VIOLATOR]: {
        label: 'Violator',
        options: [],
        display: 'danger',
        displayType: 'danger'
    }
};
export var ListingFilterEnum;
(function (ListingFilterEnum) {
    ListingFilterEnum["Category"] = "category";
    ListingFilterEnum["Status"] = "status";
    ListingFilterEnum["Sellers"] = "provider";
    ListingFilterEnum["Marketplaces"] = "marketplaces";
    ListingFilterEnum["CreatedAt"] = "created_at";
    ListingFilterEnum["RemovedAt"] = "removed_at";
    ListingFilterEnum["ReportedAt"] = "reported_at";
    ListingFilterEnum["Brands"] = "brand";
    ListingFilterEnum["SellerStatus"] = "providerStatus";
    ListingFilterEnum["Location"] = "marketplace_country";
    ListingFilterEnum["Violation"] = "violation";
    ListingFilterEnum["Reporter"] = "reporters";
    ListingFilterEnum["WhereFound"] = "where_found";
    ListingFilterEnum["Zombie"] = "zombie";
    ListingFilterEnum["IPScore"] = "ip_score";
    ListingFilterEnum["Price"] = "prices";
    ListingFilterEnum["Websites"] = "websites";
    ListingFilterEnum["Storefronts"] = "storefronts";
    ListingFilterEnum["Profiles"] = "profiles";
})(ListingFilterEnum || (ListingFilterEnum = {}));
